import initialsAvatar from "utils/initialsAvatar";
export const getProfileImage = (data, width) => {
  if (!data) return null;

  // The profile photo is the account's own picture. When it is absent we show the initials
  // avatar. We do NOT fall back to data.user.picture (the Auth0 login photo), so
  // removing the photo shows the initials, not the login photo.
  let image = data?.picture;

  if (!image) {
    return initialsAvatar(data?.name);
  }

  if (width) {
    const separator = image.includes("?") ? "&" : "?";
    image = `${image}${separator}width=${width}`;
  }

  return image;
};

export const getSelfProfileImage = (data, width) => {
  if (!data) return null;

  // Same rule as getProfileImage: own picture, else initials. No Auth0 login-photo fallback.
  let image = data?.self_picture || data?.picture;

  if (!image) {
    return initialsAvatar(data?.name);
  }

  if (width) {
    const separator = image.includes("?") ? "&" : "?";
    image = `${image}${separator}width=${width}`;
  }

  return image;
};
